import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "../../styles/global.scss";
import "./styles.scss";
import QuickLinks from "../QuickLinks";
import { Helmet } from "react-helmet";
import { usePageContext } from "../../utils/PageContext";
import SystemMessages from "../SystemMessages";
import { globalHistory } from "@reach/router";

import "../../scss/theme/blue.scss";

export default function Layout({ children }) {
  const { changeArticleType } = usePageContext();

  useEffect(() => {
    globalHistory.listen(({ action }) => {
      if (action === "PUSH") {
        window && (window.document.body.scrollTop = 0); // For Safari
        window && (window.document.documentElement.scrollTop = 0); // For Chrome, Firefox, IE and Opera
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=Manrope:wght@200;300;400;600;700;800&display=swap"
          rel="stylesheet"
        ></link>
        <link
          rel="stylesheet"
          href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
          integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
          crossorigin="anonymous"
        />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap"
          rel="stylesheet"
        ></link>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff"></meta>
        <meta name="theme-color" content="#ffffff" />
        <title>Shkolla e Magjistraturës</title>
      </Helmet>
      <SystemMessages></SystemMessages>
      <div className="site-body">
        <div className="site">
          <Header />
          <main className="main-content">{children}</main>
          <Footer />
        </div>
      </div>
    </>
  );
}
